import Vue from 'vue'
import Vuex from 'vuex'
import request from '@/servers/network' // 引用network.js
import comTools from '@/assets/js/until'
import $cookies from 'vue-cookies' // 浏览存储
const qs = require('qs');
import createLogger from 'vuex/dist/logger'

Vue.use(Vuex);
const debug = process.env.NODE_ENV != 'production'

export default new Vuex.Store({
  state: {
    apiData: {},
    wapConfig: {
      pid: '',
      gid: '',
      pmid: '',
      mid: '',
      client_type: ''
    },
    mobile: $cookies.get("mobile") || "",
    activity_type: $cookies.get('typeId') || "",
    apkAppUrl: $cookies.get('apkAppUrl') || "",
  },
  mutations: {
    setWapConfig(state, obj) { // store中的数据只能通过commit mutation来改变(可跟踪性)
      let urlObj = comTools.getRequest();
      let _isIos = comTools.isIos() ? 'ios' : 'android';
      console.log('_isIos', comTools.isIos());

      for (const index in urlObj) {
        if (urlObj.hasOwnProperty(index)) {
          const item = urlObj[index];
          $cookies.set(index, item);
          // console.log(index, item);
        }
      }
      state.wapConfig = {
        pid: comTools.isIos() ? 101 : 102,
        gid: urlObj.gid || parseInt($cookies.get('gid')) || 1002,
        pmid: urlObj.pmid || parseInt($cookies.get('pmid')) || 1,
        mid: urlObj.mid || parseInt($cookies.get('mid')) || 10000,
        client_type: urlObj.client_type || $cookies.get('client_type') || _isIos || 'h5'
      };
    },
    setSctivityTypeId(state, id) {
      state.activity_type = id
      $cookies.set('typeId', id)
    },
    setApkAppUrl(state, url) {
      state.apkAppUrl = url;
      $cookies.set('apkAppUrl', url)
    },
    setMobile(state, _mobile) {
      state.mobile = _mobile;
    }
  },
  actions: {
    // async getApiData(context) {
    //   let urlObj = comTools.getRequest();
    //   let data = {
    //     app_pid: urlObj.glPid || 100,
    //     app_gid: urlObj.glGid || 100000,
    //     app_p_mid: urlObj.glPMid || '1',
    //     app_mid: urlObj.glMid || '10000',
    //     tm: comTools.getTm(),
    //     client_type: urlObj.client || 'h5'
    //   };
    //   data.sign = comTools.querySort(data);
    //   let res = await request({
    //     method: "post",
    //     url: 'http://webapi.gamehl.my/api/v1/init/index',
    //     headers: {
    //       'Content-Type': 'application/x-www-form-urlencoded'
    //     },
    //     data: qs.stringify(data),
    //   })
    //   if (res.code == 200) {
    //     context.commit('changeApiData', res.data);
    //     // console.log('actions', res.data);
    //   } else {
    //     console.log(res.msg);
    //   }
    // }
  },
  // plugins: debug ? [createLogger()] : [],
  modules: {}
})